/** Local `datetime-local` value from an ISO timestamp. */
export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** ISO timestamp from a `datetime-local` value, or null if empty/invalid. */
export function fromLocalInput(local: string): string | null {
  if (!local) return null;
  const date = new Date(local);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}

export const DEFAULT_EVENT_HORIZON_HOURS = 72;

/**
 * Search window for events near the route.
 *
 * The drive itself is the floor, but a one-hour run must still see tonight's
 * game and tomorrow's closure — those are why the 72-hour horizon exists.
 * Passing a short horizon keeps tests and an operator who narrowed the slider
 * from being stretched back out.
 */
export function suggestedEventWindow(
  departAt?: string | null,
  durationS?: number | null,
  horizonHours: number = DEFAULT_EVENT_HORIZON_HOURS,
): { start: string; end: string } {
  const startMs = departAt ? new Date(departAt).getTime() : NaN;
  const start = Number.isFinite(startMs) ? new Date(startMs) : new Date();
  const travelS = Math.max(30 * 60, Number(durationS) || 0);
  const travelEnd = start.getTime() + (travelS + 30 * 60) * 1000;
  const horizonEnd = start.getTime() + Math.max(1, horizonHours) * 3600 * 1000;
  return { start: start.toISOString(), end: new Date(Math.max(travelEnd, horizonEnd)).toISOString() };
}
